import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Menu, X } from "lucide-react";

const LINKS = [
  { id: "beneficios", label: "Benefícios" },
  { id: "como-funciona", label: "Como Funciona" },
  { id: "simulador", label: "Simulador" },
  { id: "solucoes", label: "Soluções" },
  { id: "projetos", label: "Projetos" },
  { id: "faq", label: "FAQ" },
];

export default function Header({ onCta }) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const h = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", h);
    return () => window.removeEventListener("scroll", h);
  }, []);

  const go = (id) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.header
      initial={{ y: -80 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-white/80 backdrop-blur-xl backdrop-saturate-150 border-b border-white/40 shadow-sm" : "bg-transparent"
      }`}
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 sm:h-20 flex items-center justify-between">
        <button onClick={() => go("topo")} className="flex items-center" data-testid="logo-btn">
          <img
            src="/logo-transparent.png"
            alt="Green Era Energia"
            className={`w-auto transition-all duration-300 ${scrolled ? "h-11 sm:h-14" : "h-14 sm:h-16 drop-shadow-[0_2px_10px_rgba(0,0,0,0.45)]"}`}
          />
        </button>

        <nav className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <button
              key={l.id}
              onClick={() => go(l.id)}
              className={`text-sm font-medium transition-colors hover:text-primary ${scrolled ? "text-secondary/80" : "text-white/90"}`}
              data-testid={`nav-${l.id}`}
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="hidden lg:block">
          <button
            onClick={onCta}
            className="px-5 py-2.5 rounded-full bg-accent text-accent-foreground font-bold text-sm hover:brightness-105 active:scale-95 transition-all"
            data-testid="header-cta"
          >
            Orçamento grátis
          </button>
        </div>

        <button className="lg:hidden" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle">
          {open ? <X className={scrolled ? "text-secondary" : "text-white"} /> : <Menu className={scrolled ? "text-secondary" : "text-white"} />}
        </button>
      </div>

      {open && (
        <motion.div initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: "auto" }} className="lg:hidden bg-white border-b border-border overflow-hidden">
          <div className="px-5 py-4 flex flex-col gap-1">
            {LINKS.map((l) => (
              <button key={l.id} onClick={() => go(l.id)} className="text-left py-2.5 text-secondary/80 font-medium" data-testid={`mobile-nav-${l.id}`}>
                {l.label}
              </button>
            ))}
            <button onClick={() => { setOpen(false); onCta(); }} className="mt-2 px-5 py-3 rounded-full bg-accent text-accent-foreground font-bold" data-testid="mobile-header-cta">
              Orçamento grátis
            </button>
          </div>
        </motion.div>
      )}
    </motion.header>
  );
}
